import React, { useState, useEffect } from 'react';
import { useDesign } from '../../contexts/DesignContext';

const AnnouncementBanner = () => {
  const { designConfig } = useDesign();
  const [position, setPosition] = useState(0);

  // Get banner settings from design config or use defaults
  const bannerEnabled = designConfig?.announcement_enabled !== false;
  const bannerText = designConfig?.announcement_text || 'Welcome to our store!';
  const textColor = designConfig?.announcement_text_color || '#ffffff';
  const bgColor = designConfig?.announcement_bg_color || '#000000';
  const speed = designConfig?.announcement_speed || 'medium'; // slow, medium, fast
  // Speed mapping (pixels per frame)
  const speedMap = {
    slow: 0.5,
    medium: 1,
    fast: 2
  };

  const animationSpeed = speedMap[speed] || 1;

  useEffect(() => {
    if (!bannerEnabled || !bannerText) {
      setPosition(0);
      return;
    }

    // Wait for DOM to be ready
    const checkAndAnimate = () => {
      const bannerElement = document.getElementById('announcement-banner-text');
      if (!bannerElement) {
        // Retry after a short delay if element not found
        setTimeout(checkAndAnimate, 100);
        return;
      }

      const containerElement = bannerElement.parentElement;
      if (!containerElement) {
        setTimeout(checkAndAnimate, 100);
        return;
      }

      const containerWidth = containerElement.offsetWidth || 0;
      const textWidth = bannerElement.scrollWidth || 0;

      // If text fits, center it and don't animate
      if (textWidth <= containerWidth) {
        setPosition(0);
        return;
      }

      // Start from the right side of the container
      setPosition(containerWidth);

      // Animate from right to left
      let animationFrame;
      const animate = () => {
        setPosition((prev) => {
          const newPos = prev - animationSpeed;
          // Reset when text has scrolled completely off screen to the left
          if (newPos <= -textWidth) {
            return containerWidth;
          }
          return newPos;
        });
        animationFrame = requestAnimationFrame(animate);
      };

      animationFrame = requestAnimationFrame(animate);

      return () => {
        if (animationFrame) {
          cancelAnimationFrame(animationFrame);
        }
      };
    };

    // Small delay to ensure DOM is ready
    const timeoutId = setTimeout(checkAndAnimate, 50);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [bannerEnabled, bannerText, animationSpeed]);

  if (!bannerEnabled || !bannerText) {
    return null;
  }

  return (
    <div
      className="relative overflow-hidden text-xs md:text-sm py-1"
      style={{ backgroundColor: bgColor, color: textColor }}
    >
      <div className="relative h-6 md:h-7 overflow-hidden flex items-center">
        <div
          id="announcement-banner-text"
          className="whitespace-nowrap absolute"
          style={{
            left: 0,
            top: '50%',
            transform: `translateY(-50%) translateX(${position}px)`,
            transition: 'none',
            willChange: 'transform'
          }}
        >
          {bannerText}
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBanner;

